var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddInteractiveMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H17V10.1C18.2 10.3 19.2 10.8 20 11.5V5C20 4.5 19.5 4 19 4ZM4 15C4 15.5 4.5 16 5 16H10C10 14.9 10.3 13.9 10.8 13H4V15ZM14 0H1C0.5 0 0 0.5 0 1V15L4 11H12.7C13.4 10.5 14.2 10.2 15 10.1V1C15 0.5 14.5 0 14 0ZM15 12H17V15H20V17H17V20H15V17H12V15H15V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInteractiveMessage);
export default __webpack_public_path__ + "static/media/add-interactive-message.c26089ee.svg";
export { ForwardRef as ReactComponent };